import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderStateService } from '../../../order/services/order-state.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { Subscription } from 'rxjs';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';

@Component({
  selector: 'app-payment-return',
  templateUrl: './payment-return.component.html',
  styleUrls: ['./payment-return.component.css']
})
export class PaymentReturnComponent implements OnInit, OnDestroy {
  orderId: number;
  orderKey: string;

  private _loadOrderSubscription: Subscription;
  private _timer: any;
  private _loadingOrders: boolean;

  constructor(
    private activateRoute: ActivatedRoute,
    private orderStateService: OrderStateService,
    private router: Router,
    private loadingSpinnerService: LoadingSpinnerService,
    private shopSettingsService: ShopSettingsService,
  ) {

    this.orderId = activateRoute.snapshot.params.orderid;
    this.orderKey = activateRoute.snapshot.params.orderKey;
  }

  ngOnInit(): void {
    this._startLoadOrders();
  }

  ngOnDestroy(): void {
    this._unsubscribeSubscription();

    this._clearTimer();

    this._finishLoadOrders();
  }

  private _clearTimer(): void {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  }

  private _startLoadOrders(): void {
    if (this._loadingOrders) {
      return;
    }

    this._unsubscribeSubscription();

    this.loadingSpinnerService.show();
    this._loadingOrders = true;

    this._loadOrderAndWaitForPaymentComplete();
  }

  private _finishLoadOrders(): void {
    if (!this._loadingOrders) {
      return;
    }

    this.loadingSpinnerService.hide();
    this._loadingOrders = false;
  }

  private _unsubscribeSubscription(): void {
    if (this._loadOrderSubscription == null) {
      return;
    }

    this._loadOrderSubscription.unsubscribe();
    this._loadOrderSubscription = null;
  }

  private _loadOrderAndWaitForPaymentComplete(attempts: number = this.quantityOfAttemptsToCheckPaymentCompletion): void {
    this._loadOrderSubscription = this.orderStateService.loadOrder(this.orderId, this.orderKey).subscribe(
      result => {
        this._unsubscribeSubscription();

        if (attempts <= 0 || (this.orderStateService.order && this.orderStateService.order.isPaid)) {
          this._finishLoadOrders();
          if (this.shopSettingsService.isVUMode) {
            this.router.navigateByUrl('payment/vu-complete');
          } else {
            this.router.navigateByUrl('payment/complete');
          }
        } else {
          this._timer = setTimeout(
            () => {
              this._loadOrderAndWaitForPaymentComplete(--attempts);
            },
            1333);
        }
      }
    );
  }

  onNext(): void {
    this.router.navigateByUrl('');
  }

  get quantityOfAttemptsToCheckPaymentCompletion(): number {
    return this.shopSettingsService.quantityOfAttemptsToCheckPaymentCompletion;
  }
}
